import {Ventrata} from 'types'
import {BookingQuestions} from '../apps/Checkout/Left/pages/Activity/types'

export const getOrderQuestions = (order: Ventrata.Order) => {
  const orderQuestions: BookingQuestions[] = []

  for (const booking of order.bookings) {
    const bookingQuestions: BookingQuestions = {
      bookingUuid: booking.uuid,
      unitsQuestions: [],
    }

    for (const unitItem of booking.unitItems) {
      if (unitItem.unit.questions && unitItem.unit.questions.length > 0) {
        bookingQuestions.unitsQuestions.push({
          unitId: unitItem.id,
          questions: unitItem.unit.questions,
        })
      }
    }

    if (bookingQuestions.unitsQuestions.length > 0) {
      orderQuestions.push(bookingQuestions)
    }
  }

  return orderQuestions
}
